import { useState, useEffect } from "react";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import axiosInstance from "../utils/axiosInstance";

export const useStripeConnect = (connectedAccountId) => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState();

  useEffect(() => {
    // Only run the effect if connectedAccountId is a non-empty string
    if (connectedAccountId !== "null" && connectedAccountId.trim() !== "") {
      const fetchClientSecret = async () => {
        const backendUrl = process.env.NODE_ENV === 'production'
          ? process.env.REACT_APP_BACKEND_URL
          : 'http://localhost:8080';
        try {
          const response = await axiosInstance.post(`${backendUrl}/account_session`, {
            account: connectedAccountId,
          }, {
            headers: {
              "Content-Type": "application/json",
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
          });

          const { client_secret: clientSecret } = response.data;
          return clientSecret;
        } catch (error) {
          console.error("Failed to fetch client secret:", error.response?.data || error.message);
          //throw new Error("An error occurred: " + error.response?.data?.error || error.message);
        }
      };
      
      // Load the Stripe public key
      const stripe_key = window.location.origin === 'https://www.papirazzi.app'
      ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
      : process.env.REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY
      setStripeConnectInstance(
        loadConnectAndInitialize({
          publishableKey: stripe_key,
          fetchClientSecret,
          appearance: {
            overlays: "dialog",
            variables: {
              colorPrimary: "#635BFF",
            },
          },
        })
      );
    }
  }, [connectedAccountId]); // Only runs when connectedAccountId changes

  return stripeConnectInstance;
};

export default useStripeConnect;
